import React from 'react';

import View, { PostfixNewProps } from './index.view';
import { PostfixOptions } from './types';

export default function PostfixNew<T extends PostfixOptions>(props: PostfixNewProps<T>) {
  return <View {...props} />;
}
